import Dropdown from 'react-bootstrap/Dropdown'

import Icon from "./Icon.jsx"

import { addNotification, NotificationTypes } from '../state/actions/notificationActions.js'

const CopyRowAsJSON = ({ item, title = 'Copy Succeeded', field = 'name', messageClosure = null }) => {

	return (
		<>
			{
				(navigator && navigator.clipboard && navigator.clipboard.writeText) && (
					<Dropdown.Item onClick={
						() => {
							let message
							if (typeof messageClosure == 'function') {
								message = messageClosure(item)
							}
							else if (field in item) {
								message = `The data for ${item[field]} has been copied to your clipboard.`
							}
							else {
								message = "Data copied to clipboard."
							}
							navigator.clipboard.writeText(JSON.stringify(item, null, 2));
							addNotification(message, NotificationTypes.SUCCESS, false, title)
						}
					}>
						<Icon icon="copy" width="16" height="16"></Icon>&nbsp;Copy Row as JSON
					</Dropdown.Item>
				)
			}
		</>
	)
}
export default CopyRowAsJSON